import {
  Input,
  Flex,
  Textarea,
  Spacer,
  Button,
  Fieldset,
  Stack,
} from "@chakra-ui/react";
import { toaster } from "../ui/toaster";
import { Field } from "../ui/field";
import emailjs from "@emailjs/browser";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const ContactForm = () => {
  const form = useRef();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsLoading(true);

    emailjs
      .sendForm(
        "service_mfu5seq", //YOUR_SERVICE_ID
        "template_gksds2n", //YOUR_TEMPLATE_ID
        form.current,
        "7F7Jt3CdzxlbUXSYp" //YOUR_PUBLIC_KEY
      )
      .then(
        (result) => {
          navigate("/");
          window.scrollTo({ top: "0", behavior: "auto" });
          const promise = new Promise((resolve) => {
            setTimeout(() => resolve(), 2000);
          });

          toaster.promise(promise, {
            success: {
              title: "Message Sent!",
              description: "We'll get back to you soon",
            },
            error: {
              title: "Sending failed",
              description: "Something went wrong",
            },
            loading: { title: "Sending...", description: "Please wait" },
          });
        },
        (error) => {
          setIsLoading(false);
          console.log(error.text);
        }
      );
  };

  return (
    <Flex direction="column" py={12}>
      <form ref={form} onSubmit={sendEmail}>
        <Fieldset.Root
          bgColor="#fceeee"
          p={{ base: "5", md: "5", lg: "10" }}
          borderRadius="2xl"
        >
          {/* Name */}
          <Fieldset.Content>
            <Field id="name" required>
              <Input
                type="text"
                name="from_name"
                fontSize="sm"
                placeholder="Full Name"
                _focus={{
                  borderColor: "#a20c0b",
                  boxShadow:
                    "inset 6px 6px 10px rgba(174, 174, 192, .4), inset -6px -6px 10px #fff",
                }}
                bgColor="white"
                h="50px"
              />
            </Field>
            <Spacer h="10" />
            <Stack direction={{ base: "column", md: "row" }} gap={4}>
              <Field id="email" required>
                <Input
                  type="email"
                  name="from_email"
                  fontSize="sm"
                  placeholder="Email Address"
                  _focus={{
                    borderColor: "#a20c0b",
                    boxShadow:
                      "inset 6px 6px 10px rgba(174, 174, 192, .4), inset -6px -6px 10px #fff",
                  }}
                  bgColor="white"
                  h="50px"
                />
              </Field>
              <Spacer h="10" />

              <Field id="number" required>
                <Input
                  type="text"
                  name="from_number"
                  fontSize="sm"
                  placeholder="Phone number"
                  _focus={{
                    borderColor: "#a20c0b",
                    boxShadow:
                      "inset 6px 6px 10px rgba(174, 174, 192, .4), inset -6px -6px 10px #fff",
                  }}
                  bgColor="white"
                  h="50px"
                />
              </Field>
            </Stack>
            <Spacer h="10" />

            <Field id="message" required>
              <Textarea
                type="text"
                name="message"
                fontSize="sm"
                placeholder="Message"
                _focus={{
                  borderColor: "#a20c0b",
                  boxShadow:
                    "inset 6px 6px 10px rgba(174, 174, 192, .4), inset -6px -6px 10px #fff",
                }}
                bgColor="white"
                h="120px"
              />
            </Field>
            <Spacer h="10" />

            {/* Submit Button */}
            <Button
              isLoading={isLoading}
              loadingText="Sending"
              type="submit"
              px="10"
              variant="outline"
              border="1px"
              borderColor="#a20c0b"
              color="#a20c0b"
              borderStyle="solid"
              borderRadius="full"
              boxShadow="rgba(0, 0, 0, 0.02) 0px 1px 3px 0px"
              w="fit-content"
              fontWeight="600"
              fontSize="16px"
              transition="all 250ms"
              _hover={{
                bgColor: "transparent",
                borderColor: "#a20c0b",
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                transform: "translateY(-1px)",
              }}
              _active={{
                borderColor: "#a20c0b",
                boxShadow: "rgba(0, 0, 0, 0.06) 0px 2px 4px",
                transform: "translateY(0)",
              }}
            >
              SEND
            </Button>
          </Fieldset.Content>
        </Fieldset.Root>
      </form>
    </Flex>
  );
};

export default ContactForm;
